import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class SalesOrderStatusService {

  constructor(private http: HttpClient) { }

  url = environment.serverAPI4 + "/api/salesOrderStatus";

  newSalesOrderStatus(kitchenMaster: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, kitchenMaster)
  }

  SalesOrderStatus(Page: number, size: number, sort): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }
  getAllSalesOrderStatusDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  SalesOrderStatusSearch(query: any, Page: any, size: any, sort: any): Observable<Object> {

    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }
  syncSosPageData() {
    return this.http.get(`${this.url}/sync`);
  }

  getOrderStateById(status: any): Observable<Object> {
		return this.http.get(`${this.url}/by/${status}`);
	}

}
